<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
      <formace-centros
        :abrir = dialogCE
        :nuevo = esNuevo
        :datos = datos
        :titulo = tituloCE
        @keydown.esc = "dialogCE = false"
        @cerrarVentana = "dialogCE = false"
        @actualizarTabla = "initialize" />

        <material-card
          color="red darken-2"
          flat
          full-width
          title="Seguimiento de beneficiarios">
          
          <v-container>
            <v-layout wrap>
              <v-flex md12>
                <v-text-field
                    label = "Buscar"
                    color = "info"
                    v-model = "search"
                    append-icon="mdi-magnify"
                    placeholder="Buscar beneficiario"
                    hide-details
                />
              </v-flex>
            </v-layout>
          </v-container>

          <v-data-table
            :headers = "headers"
            :items = "data"
            :search = "search"
            rows-per-page-text = "Numero de elementos para mostrar"
            sort-by="_id"
            class="elevation-1">

            <template
              slot="items"
              slot-scope="{ item }">
              <td class="text-xs-left">
                {{ item._id }}
              </td>
              <td class="text-xs-left">
                {{ item.nombre }}
              </td>
              <td class="text-xs-left">
                {{ item.paterno }}
              </td>
              <td class="text-xs-left">
                {{ item.materno }}
              </td>
              <td class="text-xs-left">
                {{ item.telefono }}
              </td>
              <td class="text-xs-left">
                {{ item.status }}
              </td>
              <td>
                <v-tooltip
                  content-class="bottom"
                  bottom>
                  <v-btn slot="activator" icon>
                    <v-icon
                      small
                      color="blue"
                      class="mr-2"
                      @click="viewItem(item)">
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                  <span>Ver información de seguimiento</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import ServiceHandler from '../ServiceHandler';
  
  export default {
    data: () => ({
      esNuevo: true,
      tituloCE: '',
      tituloMI: '',
      dialogCE: false,
      dialogMI: false,
      showMap: false,
      showMapTitle: '',
      datos: {},
      search: "",
      headers: [
        {
          text: 'ID Beneficiario/Apoyo',
          value: '_id',
        },
        {
          text: 'Nombre',
          value: 'nombre'
        },
        {
          text: 'Ap. Paterno',
          value: 'paterno'
        },
        {
          text: 'Ap. Materno',
          value: 'materno'
        },
        {
          text: 'Telefono',
          value: 'telefono'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Acciones',
          sortable: false,
        },
      ],
      data: [],     
      editedIndex: -1,
      editedItem: {
        _id: '',
        nombre: '',
        paterno: '',
        materno: '',
        correo: '',
        telefono : '',
        status: '',
        registro: ''
      },
      defaultItem: {
        _id: '',
        nombre: '',
        paterno: '',
        materno: '',
        correo: '',
        telefono : '',
        status: '',
        registro: ''
      },
    }),   

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        try{
          this.data = await ServiceHandler.getElements("beneficiarios");
        }catch(e){
          this.error = e.message;
        }
      },
      async viewItem (item) {
        this.editedIndex = this.data.indexOf(item);
        this.editedItem = Object.assign({}, item);
        
        this.tituloMI = `Detalles de centro con id ${item._id}` 
        this.dialogMI = true;
        
      },
      
      close () {
        this.dialogCE = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      }
    }
  }
</script>
